<section [ngClass]="{ 'increase-nav': isBusinessUser }">
    <xm-expandable *ngIf="displayNotificationBanner" [expanded]="expanded">
        <xm-notification-banner [isVisible]="expanded" (closeBanner)="closeBanner()" [pageData]="currentBanner"></xm-notification-banner>
    </xm-expandable>
    <h1 class="accessibility-hidden">{{ activeTabName }}</h1>
    <div *ngIf="isBusinessUser && account" class="account-info">
        <p *ngIf="!isOrionTenant">{{pageData.accountFullLabel}} <span class="account-no">#{{account.cableAccountNumber}}</span></p>
        <p>{{ serviceAddress.address1 }} <span *ngIf="serviceAddress.address2">{{ serviceAddress.address2 }}</span><span>{{ serviceAddress.city }}, {{ serviceAddress.state }} {{ serviceAddress.zip }}</span></p>
    </div>
    <my-account-menu *ngIf="showMyAccountMenu" (activeTabName)="getActiveTabName($event)"></my-account-menu>
    <div class="my-account-content">
        <xm-account-breadcrumb data-notranslate *ngIf="!hideBreadcrumbs"></xm-account-breadcrumb>
        <ui-view name="content"></ui-view>
    </div>
    <xm-contact-bar></xm-contact-bar>
</section>
